import { Integration, Product } from '@futrli-sdk/app-store';
import { DataSource, Organisation } from '@futrli-sdk/organisations';
import { AnyObject, LoadingRequestState, NormalisedData } from '@futrli/shared-services';

/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
export type AnyHOC = any;

export type EntityTypes = Organisation | Integration | Product;

export interface ProviderRoutePayload {
  workspace_id: string;
  organisation_id: string;
  datasource_id: string;
  integration: string;
  provider: string;
  success_url: string;
  user_id: string;
}

export interface ProviderConnection {
  initiation_url: string;
  status: string;
  message: string;
  code: string;
}

export interface StoreState {
  normalised: NormalisedData<unknown>;
  loadingRequests: LoadingRequestState;
  intlReducer: AnyObject;
}

export const DISPLAY_ROW = 'ROW';
export const DISPLAY_TILE = 'TILE';

export interface IntegrationBuckets {
  [key: string]: Integration[];
}

export interface DataSourceBuckets {
  [key: string]: DataSource[];
}

export type VoidFn = () => void;

/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
export type DispatchAny = any;

// Chart of accounts structure for reporting, and consolidated forecast
export enum CoaStructureTypes {
  GROUP_BY_ORG_AND_CUSTOM_GROUPS = 'group_by_org_and_custom',
  GROUP_BY_ORG_AND_DISCARD_CUSTOM_GROUPS = 'group_by_org_and_discard',
  GROUP_BY_ANY_IDENTICAL_NAME = 'group_by_identical_names',
  FLATTEN_COA = 'flatten',
  GROUP_BY_ANY_IDENICAL_CUSTOM_GROUP_NAME = 'group_by_identical_custom_names'
}
